import { AxiosRequestConfig } from 'axios';

/**
 * Add X-Organization-ID header to API requests when organization context is available
 * This allows the backend to switch organization context for API requests
 */
export function withOrganizationHeader(organizationId?: string | null, config?: AxiosRequestConfig): AxiosRequestConfig {
  if (!organizationId) {
    return config || {};
  }

  return {
    ...config,
    headers: {
      ...config?.headers,
      'X-Organization-ID': organizationId,
    },
  };
}

/**
 * Get organization ID from localStorage for API requests
 * This is used when switching organizations to ensure API calls use the correct context
 */
export function getCurrentOrganizationId(): string | null {
  return localStorage.getItem('selected_organization_id');
}

/**
 * Set organization ID in localStorage and prepare headers for API requests
 * This should be called when switching organizations
 */
export function setCurrentOrganizationId(organizationId: string | null): AxiosRequestConfig {
  if (organizationId) {
    localStorage.setItem('selected_organization_id', organizationId);
  } else {
    localStorage.removeItem('selected_organization_id');
  }
  
  return withOrganizationHeader(organizationId);
}